








































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import PurchaseOrderCheckIn from '../../../store/entities/purchase-order-checkin'
import PurchaseOrderMedia from '../../../store/entities/purchase-order-media'
import Barcode from "../../components/bar-code.vue";
import columnMedias from './purchase-order-medias-columns';
import DateTimeMixin from '@/components/mixin/date-time-mixin';
import { mixins } from 'vue-class-component';
 @Component({
    components: { 'bar-code':Barcode}
})
export default class ViewPurchaseOrder extends mixins(DateTimeMixin, AbpBase){
    @Prop({type:Boolean,default:false}) value:boolean;
    purchaseOrderCheckIn:PurchaseOrderCheckIn=new PurchaseOrderCheckIn();
    code : string = '';
    id : number = 0;
    filterTotalCount : number = 0;
    get loading(){
        return this.$store.state.purchaseOrder.loading;
    }

    pageChange(page:number){
        this.$store.commit('purchaseOrder/setCurrentPage',page);
        this.getpage();
    }

    pagesizeChange(pagesize:number){
        this.$store.commit('purchaseOrder/setPageSize',pagesize);
        this.getpage();
    }

    get totalCount(){
        return this.filterTotalCount;
    }

    getpage(){
        // this.pagerequest.maxResultCount=this.pageSize;
        // this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
    }

    get pageSize(){
        return this.$store.state.purchaseOrder.pageSize;
    }

    get currentPage(){
        return this.$store.state.purchaseOrder.currentPage;
    }
    
    async created(){
        this.code = this.$root.$router.currentRoute.params.code;
        await this.$store
            .dispatch({
                type:'purchaseOrder/getPoCheckIn',
                data: { code : this.code}
            })
            .then(res => {
                 this.purchaseOrderCheckIn = res;
                 this.orderlist();
            });
    }

    orderlist() {
        var startIndex = (this.currentPage - 1) * this.pageSize;
        var index = 0;
        this.purchaseOrderCheckIn.poMedias.forEach(function(item) {
            item.fullUrl = Util.getAppUrlImage(item.url);
            item.orderNo = startIndex + index + 1;
            index++;
        });
    }

    columns = columnMedias;

    onGoBack(){
        this.$root.$router.push({name: 'purchaseorder/:code', params: {code: this.purchaseOrderCheckIn.poCode}});
    }

    viewDocument(item : PurchaseOrderMedia){
        window.open(item.fullUrl, "_blank");
    }
}
